import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import type React from 'react';
import viewStateVar from 'src/store/viewState';
import type { FieldDefinition, FieldTypeCode } from '../types';
import styles from './MetadataFieldDefinitionsItemStyles';

interface MetadataFieldDefinitionsItemProps {
  item: FieldDefinition;
}

const getFieldTypeLabel = (fieldType: FieldTypeCode): string => {
  const fieldTypeLabels: Record<FieldTypeCode, string> = {
    TT: 'Text',
    TA: 'Text Area',
    HT: 'HTML Snippet',
    PD: 'Pulldown',
    CB: 'Checkbox',
    RD: 'Radio Button',
    DT: 'Date and Time',
    DA: 'Date Only',
    YM: 'Year and Month',
    YO: 'Year Only',
    DATE: 'Date',
    TB: 'Table',
    MS: 'Multi Select',
  };
  return fieldTypeLabels[fieldType] || '';
};

const MetadataFieldDefinitionsItem: React.FC<MetadataFieldDefinitionsItemProps> = ({ item }) => {
  const classes = styles();

  const editFieldItemHandler = (selectedEditItemId: string): void => {
    viewStateVar({
      ...viewStateVar(),
      editFieldDefModal: true,
      editFieldDefId: selectedEditItemId,
    });
  };

  const openDeleteFieldDefModal = (deleteFieldDefId: string, deleteFieldDefName: string): void => {
    viewStateVar({
      ...viewStateVar(),
      fieldDefDeleteDialog: true,
      deleteFieldDefId: deleteFieldDefId,
      deleteFieldDefName: deleteFieldDefName,
    });
  };

  const fieldLabel = getFieldTypeLabel(item.fieldType);

  const scopeLabels: string[] = [];
  if (item.scope?.includes('asset')) {
    scopeLabels.push('Assets');
  }
  if (item.scope?.includes('collection.gallery')) {
    scopeLabels.push('Galleries');
  }

  return (
    <TableRow>
      <TableCell>
        <div>{item.name}</div>
      </TableCell>
      <TableCell>
        <Typography>{item.slug}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{fieldLabel}</Typography>
      </TableCell>
      <TableCell>{item.isEditable ? <CheckIcon color="success" /> : <CloseIcon color="error" />}</TableCell>
      <TableCell>{item.highlightIfBlank ? <CheckIcon color="success" /> : <CloseIcon color="error" />}</TableCell>
      <TableCell>
        <div className={classes.scopeCell}>
          {scopeLabels.map((label) => (
            <span key={label} className={classes.scopeTag}>
              {label}
            </span>
          ))}
        </div>
      </TableCell>
      <TableCell>
        <div className={classes.actionButtons}>
          <div className={classes.editButton}>
            <EditIcon
              onClick={() => editFieldItemHandler(item.id)}
              className="cyp-edit-icon"
              color="primary"
              style={{ marginTop: '5px', cursor: 'pointer' }}
            />
          </div>

          {!item.isSystemField && (
            <div className={classes.deleteButton}>
              <DeleteForeverIcon
                sx={{ color: 'error.main', marginTop: '5px', cursor: 'pointer' }}
                data-cyp="delete-field-definition"
                onClick={() => openDeleteFieldDefModal(item.id, item.name)}
              />
            </div>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default MetadataFieldDefinitionsItem;
